"use client";

import type { ReactElement, ReactNode } from "react";

import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuTrigger,
} from "@/components/ui/context-menu";

interface TableRowContextMenuProps {
  children: ReactElement;
  /** When null/undefined, the row renders without a context menu. */
  content?: ReactNode | null;
  className?: string;
}

/**
 * Wraps a table row so right-click opens the same action items as the row's
 * kebab menu. Pass `content={null}` to skip the menu (e.g. terminal rows).
 */
export function TableRowContextMenu({
  children,
  content,
  className,
}: TableRowContextMenuProps) {
  if (!content) return children;

  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>{children}</ContextMenuTrigger>
      <ContextMenuContent className={className}>{content}</ContextMenuContent>
    </ContextMenu>
  );
}
